import React from 'react';

export const UsageStat: React.FC<{ label: string; value: number }> = ({ label, value }) => (
  <div className="rounded-lg border border-gray-200 px-3 py-2 text-right dark:border-slate-700">
    <div className="text-xs text-gray-400 dark:text-slate-500">{label}</div>
    <div className="text-sm font-semibold text-gray-900 dark:text-slate-100">
      {value.toLocaleString()}
    </div>
  </div>
);
